import { DetectedWebView } from "@ciaopeople/cp-shatsu/ClientDetection";
import { Logger } from "@ciaopeople/cp-shatsu/Logging";
import { NativeAppConfig } from "../config/PropertyConfig.js";


export const NATIVE_APP_SUPPORTING_FIREBASE_MIN_VERSION = "3.9.0";
export const NATIVE_APP_HANDLES_LOGIN_ON_CLIENT_SIDE = "3.12.0";



function versionToComparable(versionString: string): number {
    const MAX_VER_NUMBERS=3;
    let accumulator = 0;
    if(versionString) {
        const splitten = ("" + versionString).split(".", MAX_VER_NUMBERS);
        for(let i = 0, mult = MAX_VER_NUMBERS-1; i < splitten.length; i++, mult--) {
            const pow = Math.pow(1000, mult);
            const parsed = parseInt(splitten[i]);
            accumulator += ((!isNaN(parsed)?parsed:0)*pow);
        }
    }
    return accumulator;
}


const FIREABSE_COMPARABLE_MIN_VERSION = versionToComparable(NATIVE_APP_SUPPORTING_FIREBASE_MIN_VERSION);
const LOGIN_ON_CLIENT_SIDE_COMPARABLE_MIN_VERSION = versionToComparable(NATIVE_APP_HANDLES_LOGIN_ON_CLIENT_SIDE);

export class NativeAppSupportedFeatures {


    public readonly isValidNativeApp: boolean;
    private comparableVersionNumber: number;

    constructor(private detectedWebview: DetectedWebView, 
        private config: NativeAppConfig,
        private logger: Logger) {
        //qui viene controllato che il prodotto corrispondente dell'app nativa
        //sia effettivamente corrispondente con quello del site
        //quindi nel caso in cui (non dovrebbe mai verificarsi) la visita provenga da 
        //un app nativa ciaopeople diversa da quella del prodotto, la visita viene marcata
        //come NON native app
        this.isValidNativeApp = this.detectedWebview.native_app && this.detectedWebview.extra &&
                                this.detectedWebview.extra.product && 
                                this.detectedWebview.extra.product == this.config.product;
        if(this.isValidNativeApp) {
            this.logger.info("App Product is a valid product", this.detectedWebview.extra.product);
        }
        else {
            this.logger.warn("APP product is not a valid one");
            this.detectedWebview.native_app = false;
            this.detectedWebview.different_native_app = true;
        }

        this.comparableVersionNumber = this.isValidNativeApp && this.detectedWebview.extra && 
                    this.detectedWebview.extra.nativeAppVersion?versionToComparable(this.detectedWebview.extra.nativeAppVersion):0;
    }


    public isFacebookLoginSupported(): boolean {
        return this.isValidNativeApp;
    }

    public isMultipleLoginSupported(): boolean {
        return this.comparableVersionNumber >= FIREABSE_COMPARABLE_MIN_VERSION;
    }

    public isAppleLoginSupported(): boolean {
        return this.comparableVersionNumber >= FIREABSE_COMPARABLE_MIN_VERSION;
    }

    public isGoogleLoginSupported(): boolean {
        return this.comparableVersionNumber >= FIREABSE_COMPARABLE_MIN_VERSION;
    }

    public handlesLoginOnClientSide(): boolean {
        return this.comparableVersionNumber >= LOGIN_ON_CLIENT_SIDE_COMPARABLE_MIN_VERSION;
    }

}